import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import RsvpPage from '@/pages/RsvpPage';

// The token is the credential; it is deliberately optional so a truncated or
// hand-typed link renders an explanation instead of a router validation error.
const searchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute('/rsvp')({
  component: RsvpRoute,
  validateSearch: searchSchema,
});

function RsvpRoute() {
  const { token } = Route.useSearch();
  return <RsvpPage token={token} />;
}
